import Vue from 'vue'
import Vant from 'vant'
import Router from 'vue-router'
import home from '@/pages/home/index'
import productService from '@/pages/productService/index'
import application from '@/pages/application/index'
import becomeDeveloper from '@/pages/becomeDeveloper/index'
import developerDocumentation from '@/pages/developerDocumentation/index'


import wapHome from '@/pages/wapHome/index'
import wapProducts from '@/pages/wapProducts/index'
import wapSMSPro from '@/pages/wapSMSPro/index'
import wapVDPro from '@/pages/wapVDPro/index'
import wapApplication from '@/pages/wapApplication/index'
import wapDeveloper from '@/pages/wapDeveloper/index'

import 'vant/lib/index.css'

Vue.use(Vant);
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/productService',
      name: 'productService',
      component: productService
    },
    {
      path: '/application',
      name: 'application',
      component: application
    },
    {
      path: '/becomeDeveloper',
      name: 'becomeDeveloper',
      component: becomeDeveloper
    },
    {
      path: '/developerDocumentation',
      name: 'developerDocumentation',
      component: developerDocumentation
    },
    {
      path: '/wapHome',
      name: 'wapHome',
      component: wapHome
    },
    {
      path: '/wapProducts',
      name: 'wapProducts',
      component: wapProducts
    },
    {
      path: '/wapSMSPro',
      name: 'wapSMSPro',
      component: wapSMSPro
    },
    {
      path: '/wapVDPro',
      name: 'wapVDPro',
      component: wapVDPro
    },
    {
      path:'/wapApplication',
      name:'wapApplication',
      component:wapApplication
    },{
      path:'/wapDeveloper',
      name:'wapDeveloper',
      component:wapDeveloper
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js